module.exports = __webpack_public_path__ + "static/media/banner_resourcesforyou-Primary_School.a965cac0.png";